(function() {
    document.addEventListener('DOMContentLoaded', function () {
      const tempIndicator = document.getElementById('wknd-temp-indicator');
      const unitCelsius = document.getElementById('wknd-unit-c');
      const unitFahrenheit = document.getElementById('wknd-unit-f');

      // Flag to determine the unit (true for Celsius, false for Fahrenheit)
      let isCelsius = true;

      function generateTempPoints() {
        tempIndicator.innerHTML = ''; // Clear existing points

        // Calculate the midpoint of the product temperature range
        const midTemp = (productTempRange.min + productTempRange.max) / 2;

        // Determine the range to extend on both sides
        const rangeExtension = 50; // Total extension range (can adjust as needed)
        const halfExtension = rangeExtension / 2;

        // Calculate start and end temperatures for the indicator
        let startTemp = Math.floor((midTemp - halfExtension) / 10) * 10;
        let endTemp = Math.ceil((midTemp + halfExtension) / 10) * 10;

        // Generate temperature points
        let temps = [];
        for (let temp = startTemp; temp <= endTemp; temp += 10) {
          temps.push(temp);
        }

        // Convert temperatures if needed
        let displayedTemps = temps.map(temp => {
          let displayValue = isCelsius ? `${temp}°C` : `${wkndCelsiusToFahrenheit(temp)}°F`;
          return { temp, displayValue };
        });

        // Generate temperature points
        displayedTemps.forEach(tempObj => {
          const pointDiv = document.createElement('div');
          pointDiv.classList.add('wknd-temp-point');
          pointDiv.innerHTML = `<span>${tempObj.displayValue}</span>`;
          tempIndicator.appendChild(pointDiv);
        });

        // Adjust the indicator bar
        wkndAdjustIndicatorBar(temps);
      }

      function wkndAdjustIndicatorBar(temps) {
        // Remove existing indicator bar if any
        const existingBar = tempIndicator.querySelector('.wknd-indicator-bar');
        if (existingBar) {
          existingBar.remove();
        }

        const totalRange = temps[temps.length - 1] - temps[0];
        const minPosition = ((productTempRange.min - temps[0]) / totalRange) * 100;
        const maxPosition = ((productTempRange.max - temps[0]) / totalRange) * 100;

        // Create indicator bar
        const indicatorBar = document.createElement('div');
        indicatorBar.classList.add('wknd-indicator-bar');
        indicatorBar.style.left = `${minPosition}%`;
        indicatorBar.style.width = `${maxPosition - minPosition}%`;

        tempIndicator.appendChild(indicatorBar);
      }

      function wkndCelsiusToFahrenheit(celsius) {
        return Math.round((celsius * 9/5) + 32);
      }

      // Event listeners for unit toggle buttons
      unitCelsius.addEventListener('click', function () {
        if (!isCelsius) {
          isCelsius = true;
          unitCelsius.classList.add('active');
          unitFahrenheit.classList.remove('active');
          generateTempPoints();
        }
      });

      unitFahrenheit.addEventListener('click', function () {
        if (isCelsius) {
          isCelsius = false;
          unitFahrenheit.classList.add('active');
          unitCelsius.classList.remove('active');
          generateTempPoints();
        }
      });

      // Initial load
      generateTempPoints();
    });
  })();